enum FormType {
  CREATE = "create",
  EDIT = "edit",
  READ_ONLY = "readonly",
}

export default FormType;
